import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsApacherocketmqComponent } from './simple-icons-apacherocketmq.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsApacherocketmqComponent ],
    exports:      [ SimpleIconsApacherocketmqComponent ],
    bootstrap:    []
})
export class SimpleIconsApacherocketmqModule {}
